export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/Pfizer/theme/components/scorecard/MetricsLabels/index.js